/**
 * --- CONFIRMATION DIALOG BOX ---
 *
 *  Shows a dialog box with a MESSAGE ,OK, CANCEL
 *  Returns - 0 if CANCEL is pressed, 1 if OK is pressed
 *
 * */
export const confirm = (message = "", okMessage = "Ok", cancelMessage = "Cancelar", title = "") =>
    new Promise((resolve, reject) => {
        window.notification.confirm(message, okMessage, cancelMessage, title).then(
            (response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            },
        );
    });

/**
 * --- ALERT DIALOG BOX ---
 * */
export const alert = (message = "", buttonName = "Ok", title = "") =>
    new Promise((resolve, reject) => {
        window.notification.alert(message, buttonName, title).then(
            (response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            },
        );
    });

export const i18nIdWithError = [
    "transfers.problems.finding.cbu",
    "transfers.no.accounts.error",
    "transfers.insuficient.amount.error",
    "transfers.same.account.error",
    "debin.same.account.error",
    "forms.inputFile.massivePayments.invalid.file.type",
    "forms.inputFile.massiveEcheqs.error",
    "lotPayments.file.error",
];

export const i18nIdWithConfirm = ["forms.notification.uploadFile.success"];

export const i18nIdWithAttention = [
    "forms.inputFile.massivePayments.warning",
    "forms.inputFile.massivePayments.invalid.file",
    "forms.inputFile.massiveEcheqs.warning",
];

export default {};
